module.exports = __webpack_public_path__ + "img/ic_doble-chevron.fbfea814.svg";